import React from "react";
import {
  Button,
  Col,
  FormControl,
  FormLabel,
  Row,
  Table,
} from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { BaseBean, RestReportBean } from "../ds/client_ds.js";
import {
  FabricStyleBean,
  FabricStyleDetailInquiryCriteriaBean,
  FabricStyleSalesInquiryInfoBean,
  FabricStyleSearchCriteria,
  FabricStyleSKUBean,
  FabricStyleSoldPrintRequest,
  RestFabricStyleListBeanRequest,
  RestPageListBean,
  RestReadRequest,
  RestSkuBatchInventoryListRequest,
  SKUBatchInventorySearchCriteria,
  VendorPurchaseOnOrderSearchCriteria,
} from "../ds/ds.js";
import {
  AlertToolBox,
  CollapseComponent,
  DatePickerComponent_adv,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
  ColumnDefinition,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toDownloadReportAddress,
} from "../gui_components/Util.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupCustomerModule,
  PopupFabricStyleModule,
  PopupInvoiceModule,
  PopupPurchaseOrderModule,
  PopupPurchaseReceiptModule,
  PopupVendorModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { InventoryService } from "../services/InventoryService.js";
import { ReportService } from "../services/ReportService.js";
import { VendorService } from "../services/VendorService.js";
import CustomTable from "../gui_components/CustomTable.js";
class FabricStyleSales extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.fabricCodeRef = React.createRef();
    this.itemlistCodeRef = React.createRef();
    this.state = {
      onHandQtyDataList: [],
      onPurchaseQtyDataList: [],
      isShowOnPurchaseQtyPopup: false,
      isShowOnPurchaseReceiptQtyPopup: false,
      onShippedQtyDataList: [],
      patternTypeCategories: [],
      pageTitle: "FabricStyle Sales Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowExitButton: true,
      error_list: [],
      inquiryDataList: [],
      summaryDetail: [],
      patternTypes: [],
      criteria: new FabricStyleDetailInquiryCriteriaBean(),
      inventoryDataBean: new FabricStyleSalesInquiryInfoBean(),
      criteriaViewShow: false,
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMsg: "",
      success_list: [],
      isShowFabricStyleModule: false,
      isShowCustomerModule: false,
      isShowVendorModule: false,
      isShowPurchaseOrderModule: false,
      isShowPurchaseInTransitModule: false,
      isShowPurchaseReceiptModule: false,
      isShowInvoiceModule: false,
      moduleForPopup: [],
      isShowOnShippedQtyPopup: false,
      isShowOnHandQtyPopup: false,
      colorLookupHandler: null,
      isShowColorLookup: false,
      productTypes: [],
      patternTypeData: [],
      isCollapsible_open: true,
      colorList: [],
      fabricStyleData: new FabricStyleBean(),
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricList: true,
      showAutoCompleteFabricColorList: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      alertMessage: "",
      isShowAlertLvl1: false,
      isDisableFields: false,
      onPurchaseReceiptQtyDataList: new Array(),
      barChatImage: "",
      is3PL: false,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    if (this.state.is3PL === true) {
      this.state.pageTitle = "Item Sales Inquiry";
    } else {
      this.state.pageTitle = "FabricStyle Sales Inquiry";
    }
    this.report_url = appData.reportURL;
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let productTypes = attribute_cache.productTypes;
    if (productTypes != null || productTypes != undefined) {
      productTypes.map((attr) => {
        this.state.productTypes.push(attr);
      });
    }
    let patternTypes = attribute_cache.patternTypes;
    if (patternTypes != null || patternTypes != undefined) {
      patternTypes.map((attr) => {
        this.state.patternTypes.push(attr);
      });
    }
    let patternTypeCategories = attribute_cache.patternTypeCategories;
    if (patternTypeCategories != null || patternTypeCategories != undefined) {
      patternTypeCategories.map((attr) => {
        this.state.patternTypeCategories.push(attr);
      });
    }
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
    let productTypeLookupHandler = new GenericAttributeLookupHandler(
      this.state.productTypes,
      "Product Type"
    );
    this.setState({ productTypeLookupHandler: productTypeLookupHandler });
    let patternTypeCategoryLookupHandler = new GenericAttributeLookupHandler(
      this.state.patternTypeCategories,
      "Type Category"
    );
    this.setState({
      patternTypeCategoryLookupHandler: patternTypeCategoryLookupHandler,
    });
    let patternTypeLookupHandler = new GenericAttributeLookupHandler(
      this.state.patternTypes,
      "Pattern Type"
    );
    this.setState({ patternTypeLookupHandler: patternTypeLookupHandler });
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  handleResponse = (response) => {
    let success = false;
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      success = false;
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription)
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
      success = true;
    }
    return success;
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  patternTypeCodeOnChange = (e) => {
    let patternType = e.target.value;
    this.state.showAutoCompletePatternTypeList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompletePatternTypeList;
    if (isEmpty(patternType)) {
      this.setState({
        showAutoCompletePatternTypeList: false,
      });
      let showAutoCompleteList = this.state.showAutoCompletePatternTypeList;
      let criteria = this.state.criteria;
      criteria.patternType = "";
      let suggestion = [];
      this.setState({
        showAutoCompletePatternTypeList: showAutoCompleteList,
        criteria: criteria,
        patternTypePageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "patternType" &&
      showAutoCompleteList === true &&
      patternType !== ""
    ) {
      this.readPatternTypeBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
    this.readPatternType(patternType);
  };
  readPatternType = (patternType) => {
    let patternTypeBean = null;
    let patternTypeData = null;
    this.state.patternTypes.map((ln) => {
      if (ln.code === patternType) {
        patternTypeBean = ln;

        patternTypeData = new BaseBean();
        patternTypeData.code = ln.code;
        patternTypeData.description = ln.description;
      }
    });
    if (!isEmpty(patternTypeBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.patternType = patternTypeBean.code;
      this.state.showAutoCompletePatternTypeList = false;
      let showAutoCompleteList = this.state.showAutoCompletePatternTypeList;
      this.setState({
        criteria: temp_criteria,
        showAutoCompletePatternTypeList: showAutoCompleteList,
      });
    }
  };
  readPatternTypeBySearchString = (searchString) => {
    let patternTypeData = this.state.patternTypes;
    let simpleAutoCompleteList = new Array();
    if (patternTypeData.length > 0 && patternTypeData != null) {
      patternTypeData.map((sp) => {
        let patternTypeBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(patternTypeBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      patternTypePageListForAutoCompleteList: filteredSuggestions,
    });
  };
  patternTypeEnterKeyEventHandler = (e) => {
    let patternType = e.target.value;
    this.readPatternType(patternType);
    this.setState({
      patternTypePageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompletePatternTypeList = (showAutoCompleteList) => {
    this.setState({ showAutoCompletePatternTypeList: showAutoCompleteList });
  };
  patternTypeCategoryCodeOnChange = (e) => {
    let patternTypeCategory = e.target.value;
    this.state.showAutoCompletePatternTypeCategoryList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList =
      this.state.showAutoCompletePatternTypeCategoryList;
    if (isEmpty(patternTypeCategory)) {
      this.setState({
        showAutoCompletePatternTypeList: false,
      });
      let showAutoCompleteList =
        this.state.showAutoCompletePatternTypeCategoryList;
      let criteria = this.state.criteria;
      criteria.patternType = "";
      let suggestion = [];
      this.setState({
        showAutoCompletePatternTypeCategoryList: showAutoCompleteList,
        criteria: criteria,
        patternTypeCategoryPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "patternTypeCategory" &&
      showAutoCompleteList === true &&
      patternTypeCategory !== ""
    ) {
      this.readPatternTypeCategoryBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
    this.readPatternTypeCategory(patternTypeCategory);
  };
  readPatternTypeCategory = (patternTypeCategory) => {
    let patternTypeCategoryBean = null;
    let patternTypeCategoryData = null;
    this.state.patternTypeCategories.map((ln) => {
      if (ln.code === patternTypeCategory) {
        patternTypeCategoryBean = ln;
        patternTypeCategoryData = new BaseBean();
        patternTypeCategoryData.code = ln.code;
        patternTypeCategoryData.description = ln.description;
      }
    });
    if (!isEmpty(patternTypeCategoryBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.patternTypeCategory = patternTypeCategoryBean.code;
      this.state.showAutoCompletePatternTypeCategoryList = false;
      let showAutoCompleteList =
        this.state.showAutoCompletePatternTypeCategoryList;
      this.setState({
        criteria: temp_criteria,
        showAutoCompletePatternTypeCategoryList: showAutoCompleteList,
      });
    }
  };
  readPatternTypeCategoryBySearchString = (searchString) => {
    let patternTypeCategoryData = this.state.patternTypeCategories;
    let simpleAutoCompleteList = new Array();
    if (patternTypeCategoryData.length > 0 && patternTypeCategoryData != null) {
      patternTypeCategoryData.map((sp) => {
        let patternTypeCategoryBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(patternTypeCategoryBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      patternTypeCategoryPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  patternTypeCategoryEnterKeyEventHandler = (e) => {
    let patternTypeCategory = e.target.value;
    this.readPatternTypeCategory(patternTypeCategory);
    this.setState({
      patternTypeCategoryPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompletePatternTypeCategoryList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompletePatternTypeCategoryList: showAutoCompleteList,
    });
  };
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.state.showAutoCompleteFabricList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricList: showAutoCompleteList,
        criteria: criteria,
        fabricPageListForAutoCompleteList: suggestion,
        isShowColorLookup: false,
        colorList: [],
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
    this.readandsetFabricStyleDetail(fabricStyleCode);
  };
  readandsetFabricStyleDetailResponse = (response) => {
    let criteria = this.state.criteria;
    this.setState({
      isFabricStyleDataLoding: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        criteria.fabricStyleName = fabricStyle.description;
        let colors = fabricStyle.colors;
        let finalColorList = [];
        colors.map((ent) => {
          let colorBean = new BaseBean();
          colorBean.code = ent.fabricStyleColorCode;
          colorBean.description = ent.fabricStyleColorName;
          finalColorList.push(colorBean);
        });
        this.setState({ colorLookupHandler: null });
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color"
          );
          this.setState({
            colorLookupHandler: colorLookupHandler,
            criteria: criteria,
            isShowColorLookup: true,
            colorList: finalColorList,
            fabricStyleData: fabricStyle,
          });
        }
      }
    }
  };
  readandsetFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    this.setState({ isFabricStyleDataLoding: true });
    FabricStyleService.readFabricStyle(
      input,
      this.readandsetFabricStyleDetailResponse,
      this.errorCallBack
    );
  };

  readFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.errorCallBack
    );
  }
  readByFabricCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        let simpleItemBean = {
          code: fabricStyle.fabricStyleCode,
          description: fabricStyle.fabricStyleName,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  fabricEnterKeyEventHandler = (e) => {
    this.readandsetFabricStyleDetail(e.target.value);
    this.setState({ fabricPageListForAutoCompleteList: new Array() });
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
    });
  };
  displayAutoCompleteFabricList = (showAutoCompleteFabricList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteFabricList });
  };
  onFabricColourCodeChange = (e) => {
    this.state.showAutoCompleteFabricColorList = true;
    let colorCode = e.target.value;
    let showAutoCompleteFabricColorList =
      this.state.showAutoCompleteFabricColorList;
    if (isEmpty(colorCode)) {
      this.state.showAutoCompleteFabricColorList = false;
      let showAutoCompleteFabricColorList =
        this.state.showAutoCompleteFabricColorList;
      let criteria = this.state.criteria;
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricColorList: showAutoCompleteFabricColorList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "colorCode" &&
      showAutoCompleteFabricColorList === true &&
      colorCode !== ""
    ) {
      this.readFabricColourBySearchString(e.target.value);
    }
    this.fabricStyleColorSelected(e.target.value);
  };
  readFabricColourBySearchString(searchString) {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    if (!isEmpty(fabricStyle)) {
      fabricStyle.fabricStyleSkus.map((sku) => {
        if (
          sku.fabricStyleCode == criteria.fabricStyleCode &&
          sku.fabricStyleColorCode == searchString
        )
          skuBean = sku;
      });
    }
    criteria.colorCode = searchString;
    let colorList = this.state.colorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricColourEnterKeyEventHandler = (e) => {
    this.fabricStyleColorSelected(e.target.value);
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricColorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricColorList: showAutoCompleteList });
  };
  fabricStyleColorSelected = (colorCode) => {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    if (!isEmpty(fabricStyle)) {
      fabricStyle.fabricStyleSkus.map((sku) => {
        if (
          sku.fabricStyleCode == criteria.fabricStyleCode &&
          sku.fabricStyleColorCode == colorCode
        )
          skuBean = sku;
      });
    }
    criteria.colorCode = colorCode;
    this.setState({ criteria: criteria });
  };
  onProductTypeCodeChange = (e) => {
    let productType = e.target.value;
    this.state.showAutoCompleteProductTypeList = true;
    let temp_criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteProductTypeList;
    if (isEmpty(productType)) {
      this.state.showAutoCompleteProductTypeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteProductTypeList;
      let criteria = this.state.criteria;
      criteria.productType = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteProductTypeList: showAutoCompleteList,
        criteria: criteria,
        productTypePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && productType !== "") {
      this.readProductTypeBySearchString(productType);
    }
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ criteria: temp_criteria });
    this.readProductType(productType);
  };
  readProductType = (productType) => {
    let productTypeBean = null;
    let productTypeData = null;
    this.state.productTypes.map((ln) => {
      if (ln.code === productType) {
        productTypeBean = ln;
        productTypeData = new BaseBean();
        productTypeData.code = ln.code;
        productTypeData.description = ln.description;
      }
    });
    if (!isEmpty(productTypeBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.productType = productTypeBean.code;
      this.state.showAutoCompleteProductTypeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteProductTypeList;
      this.setState({
        criteria: temp_criteria,
        showAutoCompleteProductTypeList: showAutoCompleteList,
      });
    }
  };
  readProductTypeBySearchString = (searchString) => {
    let productTypeData = this.state.productTypes;
    let simpleAutoCompleteList = new Array();
    if (productTypeData.length > 0 && productTypeData != null) {
      productTypeData.map((sp) => {
        let productTypeBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(productTypeBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      productTypePageListForAutoCompleteList: filteredSuggestions,
    });
  };
  productTypeEnterKeyEventHandler = (e) => {
    let productType = e.target.value;
    this.readProductType(productType);
    this.setState({
      productTypePageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteProductTypeList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteProductTypeList: showAutoCompleteList });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  handleResponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription)
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    this.loadFabricSalesInquiryList(criteria);
  };
  loadFabricSalesInquiryList = (listRequest) => {
    if (SecurityAccessManager.FabricStyleSalesInquiry_IsAccessible()) {
      ReportService.getFabricStyleSoldInquiryDetails(
        listRequest,
        this.loadFabricSalesPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadFabricSalesPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      let resultList = new Array();
      let summaryDetail = new Array();
      summaryDetail = response.data.result;
      if (!isEmptyArray(response.data.result.fabricStyleInfos)) {
        resultList = response.data.result.fabricStyleInfos;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      this.setState({
        inquiryDataList: resultList,
        summaryDetail: summaryDetail,
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        isShowItemCatelogButton: true,
        isShowPoInputExcelButton: true,
        isCollapsible_open: false,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showHideSecondHeader = () => {
    let tempIsCollapsible_open = !this.state.isCollapsible_open;
    this.setState({ isCollapsible_open: tempIsCollapsible_open });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.hideAlertCallBack();
    this.hideAlertCallBackLvl1();
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new FabricStyleDetailInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleName = "";
    this.setState({
      criteria: criteria,
      isShowColorLookup: false,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricStyleData: new Array(),
      colorList: [],
      isDisableFields: false,
    });
    this.hideAlertCallBack();
  };
  resetInquiry = () => {
    let criteria = new FabricStyleDetailInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleName = "";
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      summaryDetail: [],
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowColorLookup: false,
      fabricStyleData: [],
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricStyleData: new Array(),
      colorList: [],
      isCollapsible_open: true,
      isDisableFields: false,
    });
    this.hideAlertCallBack();
  };
  generatePDF = () => {
    this.generateReport(1);
  };
  generateExcel = () => {
    this.generateReport(2);
  };
  generateReport = (reportType) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new FabricStyleSoldPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.FabricStyleSalesInquiryPDFReport_IsAccessible()
      ) {
        ReportService.generateFabricStyleSoldPrintReport(
          listRequest,
          this.generateFabricSalesPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.FabricStyleSalesInquiryExcelReport_IsAccessible()
      ) {
        ReportService.generateFabricStyleSoldPrintReport(
          listRequest,
          this.generateFabricSalesPageExcelResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
    generateFabricSalesPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateFabricSalesPageExcelResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        // window.open(this.report_url + reportFilePath);
         let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
              window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  onHandQuantityClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let inventoryDataBean = this.state.inventoryDataBean;
      inventoryDataBean.companyCode = this.companyCode;
      inventoryDataBean.fabricStyleCode = rowData.fabricStyleCode;
      inventoryDataBean.fabricStyleName = rowData.fabricStyleName;
      inventoryDataBean.colorCode = rowData.colorCode;
      this.setState({ inventoryDataBean: inventoryDataBean });
      let qtyCriteria = new SKUBatchInventorySearchCriteria();
      qtyCriteria.companyCode = this.companyCode;
      qtyCriteria.fabricStyleCode = rowData.fabricStyleCode;
      qtyCriteria.colorCode = rowData.colorCode;
      let pageInput = new RestPageListBean();
      pageInput.pageSize = 20;
      pageInput.currentPage = 1;
      let listRequest = new RestSkuBatchInventoryListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = qtyCriteria;
      if (rowData.onHandQty > 0) {
        this.setState({
          isShowProgressBarPopup: true,
          progressLoadingText: "Loading OnHand Qty...",
        });
        this.loadOnHandQtyListPage(listRequest);
      } else {
        let errMsg = "No data found";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadOnHandQtyListPage = (listRequest) => {
    InventoryService.getOpenSkuBatchInventories(
      listRequest,
      this.loadOnHandQtyPageResponse,
      this.errorCallBack
    );
  };
  loadOnHandQtyPageResponse = (response) => {
    if (
      response.data != null &&
      response.data.skuBatchInventoryPageList != null
    ) {
      let onHandQtyList = [];
      if (
        !isEmptyArray(
          response.data.skuBatchInventoryPageList.skuBatchInventories
        )
      ) {
        onHandQtyList =
          response.data.skuBatchInventoryPageList.skuBatchInventories;
        this.setState({
          onHandQtyDataList: onHandQtyList,
          isShowOnHandQtyPopup: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
  };
  onPurchaseQuantityClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let inventoryDataBean = this.state.inventoryDataBean;
      inventoryDataBean.companyCode = this.companyCode;
      inventoryDataBean.fabricStyleCode = rowData.fabricStyleCode;
      inventoryDataBean.fabricStyleName = rowData.fabricStyleName;
      inventoryDataBean.colorCode = rowData.colorCode;
      this.setState({ inventoryDataBean: inventoryDataBean });
      let qtyCriteria = new VendorPurchaseOnOrderSearchCriteria();
      qtyCriteria.companyCode = this.companyCode;
      qtyCriteria.fabricStyleCode = rowData.fabricStyleCode;
      qtyCriteria.colorCode = rowData.colorCode;
      if (rowData.purchaseOrderQty > 0) {
        this.setState({
          isShowProgressBarPopup: true,
          progressLoadingText: "Loading Purchase qty...",
        });
        this.loadOnPurchaseQtyListPage(qtyCriteria);
      } else {
        let errMsg = "No data found";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadOnPurchaseQtyListPage = (listRequest) => {
    VendorService.getVendorPurchaseOnOrderDetails(
      listRequest,
      this.loadOnPurchaseQtyPageResponse,
      this.errorCallBack
    );
  };
  loadOnPurchaseQtyPageResponse = (response) => {
    if (response.data != null && response.data.orderDetailsResult != null) {
      let onPurchaseQtyList = new Array();
      if (!isEmptyArray(response.data.orderDetailsResult.onOrderInfoDetails)) {
        onPurchaseQtyList = response.data.orderDetailsResult.onOrderInfoDetails;
        this.setState({
          onPurchaseQtyDataList: onPurchaseQtyList,
          isShowOnPurchaseQtyPopup: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
  };
  onPurchaseReceiptQuantityClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let inventoryDataBean = this.state.inventoryDataBean;
      inventoryDataBean.companyCode = this.companyCode;
      inventoryDataBean.fabricStyleCode = rowData.fabricStyleCode;
      inventoryDataBean.fabricStyleName = rowData.fabricStyleName;
      inventoryDataBean.colorCode = rowData.colorCode;
      this.setState({ inventoryDataBean: inventoryDataBean });
      let qtyCriteria = new FabricStyleDetailInquiryCriteriaBean();
      qtyCriteria.companyCode = this.companyCode;
      qtyCriteria.fabricStyleCode = rowData.fabricStyleCode;
      qtyCriteria.colorCode = rowData.colorCode;
      if (rowData.receiptReceivedQty > 0) {
        this.setState({
          isShowProgressBarPopup: true,
          progressLoadingText: "Loading purchase Receipt Qty...",
        });
        this.loadOnPurchaseReceiptQtyListPage(qtyCriteria);
      } else {
        let errMsg = "No data found";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
  };
  loadOnPurchaseReceiptQtyListPage = (listRequest) => {
    ReportService.getPurchaseReceiptReceivedDetails(
      listRequest,
      this.loadOnPurchaseReceiptQtyPageResponse,
      this.errorCallBack
    );
  };
  loadOnPurchaseReceiptQtyPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      let onPurchaseReceiptQtyList = new Array();
      if (!isEmptyArray(response.data.result.receivedDatas)) {
        onPurchaseReceiptQtyList = response.data.result.receivedDatas;
        this.setState({
          onPurchaseReceiptQtyDataList: onPurchaseReceiptQtyList,
          isShowOnPurchaseReceiptQtyPopup: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
  };
  onShippedQtyClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let inventoryDataBean = this.state.inventoryDataBean;
      inventoryDataBean.companyCode = this.companyCode;
      inventoryDataBean.fabricStyleCode = rowData.fabricStyleCode;
      inventoryDataBean.fabricStyleName = rowData.fabricStyleName;
      inventoryDataBean.colorCode = rowData.colorCode;
      inventoryDataBean.totalShippedQuantity = rowData.totalShippedQuantity;
      inventoryDataBean.totalSoldAmount = rowData.totalSoldAmount;
      this.setState({ inventoryDataBean: inventoryDataBean });
      let qtyCriteria = new FabricStyleDetailInquiryCriteriaBean();
      qtyCriteria.companyCode = this.companyCode;
      qtyCriteria.fabricStyleCode = rowData.fabricStyleCode;
      qtyCriteria.colorCode = rowData.colorCode;
      qtyCriteria.totalShippedQuantity = rowData.totalShippedQuantity;
      qtyCriteria.totalSoldAmount = rowData.totalSoldAmount;
      let pageInput = new RestPageListBean();
      pageInput.pageSize = 20;
      pageInput.currentPage = 1;
      if (rowData.totalShippedQuantity > 0) {
        this.setState({
          isShowProgressBarPopup: true,
          progressLoadingText: "Loading shipped qty...",
        });
        this.loadOnShippedQtyListPage(qtyCriteria);
      } else {
        let errMsg = "No data found";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadOnShippedQtyListPage = (qtyCriteria) => {
    ReportService.getFabricStyleInvoiceDetails(
      qtyCriteria,
      this.loadOnShippedQtyPageResponse,
      this.errorCallBack
    );
  };
  loadOnShippedQtyPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.pageList != null) {
      let onShippedQtyList = new Array();
      if (!isEmptyArray(response.data.pageList.infoBeans)) {
        onShippedQtyList = response.data.pageList.infoBeans;
        this.setState({
          onShippedQtyDataList: onShippedQtyList,
          isShowOnShippedQtyPopup: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
  };
  closeAlertModalCallBackLvl1 = (isShowPopup) => {
    this.setState({
      isShowAlertLvl1: isShowPopup,
      isShowOnHandQtyPopup: isShowPopup,
      isShowOnPurchaseReceiptQtyPopup: isShowPopup,
      isShowOnPurchaseQtyPopup: isShowPopup,
      isShowOnShippedQtyPopup: isShowPopup,
    });
  };
  hideAlertCallBackLvl1 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl1: isDisplayed });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewFabricModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowFabricStyleModule: true,
          moduleForPopup: (
            <PopupFabricStyleModule
              fabricStyleCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewCustomerModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewVendorModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowVendorModule: true,
          moduleForPopup: (
            <PopupVendorModule
              vendorCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewPoModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseOrderModule: true,
          moduleForPopup: (
            <PopupPurchaseOrderModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewPurchaseReceiptModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseReceiptModule: true,
          moduleForPopup: (
            <PopupPurchaseReceiptModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewInvoiceModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowInvoiceModule: true,
          moduleForPopup: (
            <PopupInvoiceModule
              invoiceCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowFabricStyleModule: isOpen,
      isShowCustomerModule: isOpen,
      isShowVendorModule: isOpen,
      isShowPurchaseOrderModule: isOpen,
      isShowPurchaseReceiptModule: isOpen,
      isShowInvoiceModule: isOpen,
      moduleForPopup: [],
    });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item " : "FabricStyle#",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "8", "", "wt-6", "wt-6")
        .setClickDetails(true, false, this.viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(this.state.is3PL ? "Item Name" : "FabricStyle Name", "fabricStyleName", true)
        .setStyleDetails("left", "8", "", "wt-6", "wt-6")

    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "4", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Style", "productTypeCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Type", "patternTypeCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Total ShippedQty", "totalShippedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
        .setSubHeaderDetails(true, "totalShippedQuantity")
        .setClickDetails(true, false, this.onShippedQtyClick, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PurchaseOrder Qty", "purchaseOrderQty", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
        .setSubHeaderDetails(true, "purchaseOrderQty")
        .setClickDetails(true, false, this.onPurchaseQuantityClick, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Received Qty", "receiptReceivedQty", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
        .setSubHeaderDetails(true, "receiptReceivedQty")
        .setClickDetails(true, false, this.onPurchaseReceiptQuantityClick, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQty", "onHandQty", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
        .setSubHeaderDetails(true, "totalOnHandQuantity")
        .setClickDetails(true, false, this.onHandQuantityClick, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Total Sales%", "salesPercentage", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Sold Amount", "totalSoldAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
        .setSubHeaderDetails(true, "totalSalesAmount")
    );
    return columns;
  };
  fabricSoldColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Date", "invoiceDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice#", "invoiceNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewInvoiceModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "6", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewCustomerModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "customerName", true)
        .setStyleDetails("left", "8", "", "wt-6", "wt-6")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerPO#", "customerPONumber", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ShippedQty", "shippedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Amount", "lineTotalAmount", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    return columns;
  };
  purchaseOnOrderColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewPoModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("P.OStartDate", "purchaseOrderStartDate", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("P.OStopDate", "purchaseOrderStopDate", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Vendor", "vendorCode", true)
        .setStyleDetails("left", "6", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewVendorModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("VendorName", "vendorName", true)
        .setStyleDetails("left", "8", "", "wt-6", "wt-6")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Width", "widthCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "orderUom", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Sku", "skuNumber", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OnOrderQty", "onOrderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    return columns;
  };
  purchaseReceiptOnOrderColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Receipt#", "purchaseOrderReceiptNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewPurchaseReceiptModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewPoModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Receipt Date", "receiptDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Vendor", "vendorCode", true)
        .setStyleDetails("left", "6", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewVendorModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("VendorName", "vendorName", true)
        .setStyleDetails("left", "8", "", "wt-6", "wt-6")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ReceivedQty", "receivedQuantity", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    return columns;
  };
  onHandQtyColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewPoModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Receipt#", "purchaseOrderReceiptNumber", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewPurchaseReceiptModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ReceivedDate", "receivedDate", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(this.state.is3PL ? "Inventory#" : "RollSKU#", "rollSkuNumber", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
    );
    return columns;
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let summaryDetail = this.state.summaryDetail;
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = pageList.pageSize;
    let totalCount = pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    let isLoading = this.state.isLoading;
    let onHandQtyDataList = this.state.onHandQtyDataList;
    let onShippedQtyDataList = this.state.onShippedQtyDataList;
    let onPurchaseQtyDataList = this.state.onPurchaseQtyDataList;
    let inventoryDataBean = this.state.inventoryDataBean;
    let onPurchaseReceiptQtyDataList = this.state.onPurchaseReceiptQtyDataList;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          loadingText={this.state.loadingText}
          isLoading={this.state.isLoading}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
          onModuleExit={this.onModuleExit}
        />
        <CriteriaView
          {...this.state}
          onChange={this.onChange}
          criteria={this.state.criteria}
          showHideSecondHeader={this.showHideSecondHeader}
          displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
          fabricCodeOnChange={this.fabricCodeOnChange}
          fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
          fabricColourEnterKeyEventHandler={
            this.fabricColourEnterKeyEventHandler
          }
          displayAutoCompleteFabricColorList={
            this.displayAutoCompleteFabricColorList
          }
          onFabricColourCodeChange={this.onFabricColourCodeChange}
          productTypeEnterKeyEventHandler={this.productTypeEnterKeyEventHandler}
          displayAutoCompleteProductTypeList={
            this.displayAutoCompleteProductTypeList
          }
          onProductTypeCodeChange={this.onProductTypeCodeChange}
          patternTypeEnterKeyEventHandler={this.patternTypeEnterKeyEventHandler}
          displayAutoCompletePatternTypeList={
            this.displayAutoCompletePatternTypeList
          }
          patternTypeCodeOnChange={this.patternTypeCodeOnChange}
          patternTypeCategoryEnterKeyEventHandler={
            this.patternTypeCategoryEnterKeyEventHandler
          }
          displayAutoCompletePatternTypeCategoryList={
            this.displayAutoCompletePatternTypeCategoryList
          }
          patternTypeCategoryCodeOnChange={this.patternTypeCategoryCodeOnChange}
        />
        {this.state.isInquiryDatasFound && (
          <div className="mt-3">
            <CustomTable
              data={inquiryDataList}
              columns={this.inquiryColumns()}
              subHeaderData={summaryDetail}

            />
          </div>
        )}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowVendorModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowPurchaseOrderModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowPurchaseReceiptModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowOnShippedQtyPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel1"}
          closeAlertModalCallBack={this.closeAlertModalCallBackLvl1}
          title={
            this.state.is3PL ? "Item  Sold Details" : "Fabric Sold Details"
          }
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl1}
              hideAlertCallBack={this.hideAlertCallBackLvl1}
            />
          }
          content={
            <div className="">
              <Row>
                <Col sm="1">
                  <FormLabel>Company Code</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    value={inventoryDataBean.companyCode}
                    name={"companyCode"}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  {this.state.is3PL ? (
                    <FormLabel>Item</FormLabel>
                  ) : (
                    <FormLabel>FabricStyle</FormLabel>
                  )}
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="fabricStyleCode"
                    type="text"
                    value={inventoryDataBean.fabricStyleCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="4">
                  <InputTextbox
                    name="fabricStyleName"
                    type="text"
                    value={inventoryDataBean.fabricStyleName}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  <FormLabel>ColorCode</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="colorCode"
                    type="text"
                    value={inventoryDataBean.colorCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>TotalQty</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    value={inventoryDataBean.totalShippedQuantity}
                    name={"totalShippedQuantity"}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>TotalAmount</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    value={inventoryDataBean.totalSoldAmount}
                    className={"summary_input text-right"}
                    name={"totalSoldAmount"}
                    disabled={true}
                  />
                </Col>
              </Row>
              <div className="mt-3">
                <CustomTable
                  data={onShippedQtyDataList}
                  columns={this.fabricSoldColumns()}
                />
              </div>
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowOnPurchaseQtyPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel1"}
          closeAlertModalCallBack={this.closeAlertModalCallBackLvl1}
          title={"Purchase OnOrder Details"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl1}
              hideAlertCallBack={this.hideAlertCallBackLvl1}
            />
          }
          content={
            <div className="">
              <Row>
                <Col sm="1">
                  {this.state.is3PL ? (
                    <FormLabel>Item</FormLabel>
                  ) : (
                    <FormLabel>FabricStyle</FormLabel>
                  )}
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="fabricStyleCode"
                    type="text"
                    value={inventoryDataBean.fabricStyleCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="4">
                  <InputTextbox
                    name="fabricStyleName"
                    type="text"
                    value={inventoryDataBean.fabricStyleName}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>ColorCode</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="colorCode"
                    type="text"
                    value={inventoryDataBean.colorCode}
                    disabled={true}
                  />
                </Col>
              </Row>
              <div className="mt-3">
                <CustomTable
                  data={onPurchaseQtyDataList}
                  columns={this.purchaseOnOrderColumns()}
                />
              </div>
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowOnPurchaseReceiptQtyPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel1"}
          closeAlertModalCallBack={this.closeAlertModalCallBackLvl1}
          title={"PurchaseReceipt OnOrder Details"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl1}
              hideAlertCallBack={this.hideAlertCallBackLvl1}
            />
          }
          content={
            <div className="">
              <Row>
                <Col sm="1">
                  {this.state.is3PL ? (
                    <FormLabel>Item</FormLabel>
                  ) : (
                    <FormLabel>FabricStyle</FormLabel>
                  )}
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="fabricStyleCode"
                    type="text"
                    value={inventoryDataBean.fabricStyleCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="4">
                  <InputTextbox
                    name="fabricStyleName"
                    type="text"
                    value={inventoryDataBean.fabricStyleName}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>ColorCode</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="colorCode"
                    type="text"
                    value={inventoryDataBean.colorCode}
                    disabled={true}
                  />
                </Col>
              </Row>
              <div className="mt-3">
                <CustomTable
                  data={onPurchaseReceiptQtyDataList}
                  columns={this.purchaseReceiptOnOrderColumns()}
                />
              </div>
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowOnHandQtyPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel1"}
          closeAlertModalCallBack={this.closeAlertModalCallBackLvl1}
          title={"OnHandQty"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl1}
              hideAlertCallBack={this.hideAlertCallBackLvl1}
            />
          }
          content={
            <div className="">
              <Row>
                <Col sm="1">
                  {this.state.is3PL ? (
                    <FormLabel>Item</FormLabel>
                  ) : (
                    <FormLabel>FabricStyle</FormLabel>
                  )}
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="fabricStyleCode"
                    type="text"
                    value={inventoryDataBean.fabricStyleCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="4">
                  <InputTextbox
                    name="fabricStyleName"
                    type="text"
                    value={inventoryDataBean.fabricStyleName}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>ColorCode</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="colorCode"
                    type="text"
                    value={inventoryDataBean.colorCode}
                    disabled={true}
                  />
                </Col>
              </Row>
               <div className="mt-3">
                <CustomTable
                  data={onHandQtyDataList}
                  columns={this.onHandQtyColumns()}
                />
              </div>
            </div>
          }
        />
      </div>
    );
  }
}

class CriteriaView extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.fabricCodeRef = React.createRef();
  }
  componentDidMount() {
    this.setFocus();
  }
  setFocus() {
    if (this.fabricCodeRef.current != null) {
      this.fabricCodeRef.current.focus();
    }
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  patternTypeCodeOnChange = (e) => {
    this.props.patternTypeCodeOnChange(e);
  };
  patternTypeCategoryCodeOnChange = (e) => {
    this.props.patternTypeCategoryCodeOnChange(e);
  };
  fabricCodeOnChange = (e) => {
    this.props.fabricCodeOnChange(e);
  };
  fabricEnterKeyEventHandler = (e) => {
    this.props.fabricEnterKeyEventHandler(e);
  };
  displayAutoCompleteFabricList = () => {
    this.props.displayAutoCompleteFabricList();
  };
  displayAutoCompletePatternTypeList = () => {
    this.props.displayAutoCompletePatternTypeList();
  };
  onFabricColourCodeChange = (e) => {
    this.props.onFabricColourCodeChange(e);
  };
  fabricColourEnterKeyEventHandler = (e) => {
    this.props.fabricColourEnterKeyEventHandler(e);
  };
  displayAutoCompleteFabricColorList = () => {
    this.props.displayAutoCompleteFabricColorList();
  };
  onProductTypeCodeChange = (e) => {
    this.props.onProductTypeCodeChange(e);
  };
  productTypeEnterKeyEventHandler = (e) => {
    this.props.productTypeEnterKeyEventHandler(e);
  };
  displayAutoCompleteProductTypeList = () => {
    this.props.displayAutoCompleteProductTypeList();
  };
  patternTypeCategoryEnterKeyEventHandler = (e) => {
    this.props.patternTypeCategoryEnterKeyEventHandler(e);
  };
  displayAutoCompletePatternTypeCategoryList = () => {
    this.props.displayAutoCompletePatternTypeCategoryList();
  };
  patternTypeEnterKeyEventHandler = (e) => {
    this.props.patternTypeEnterKeyEventHandler(e);
  };
  showHideSecondHeader = (e) => {
    if (e.detail === 1) this.props.showHideSecondHeader();
  };
  render() {
    let criteria = this.props.criteria;
    let isDisableFields = this.props.isDisableFields;
    return (
      <div>
        <Row className="d-flex justify-content-left">
          <Col sm="1">
            {" "}
            {this.props.is3PL ? (
              <FormLabel>Item</FormLabel>
            ) : (
              <FormLabel>FabricStyle</FormLabel>
            )}
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.fabricCodeOnChange}
              ref={this.fabricCodeRef}
              name="fabricStyleCode"
              placeholder="Item"
              value={criteria.fabricStyleCode}
              lookupRequired={true}
              lookupHandler={this.props.fabricLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={this.fabricEnterKeyEventHandler}
              autoCompleteListData={
                this.props.fabricPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteFabricList}
              showAutoCompleteList={this.props.showAutoCompleteFabricList}
              disabled={isDisableFields}
            />
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.onChange}
              name="fabricStyleName"
              placeholder="Item"
              value={criteria.fabricStyleName}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Color</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.onFabricColourCodeChange}
              name="colorCode"
              placeholder="Color"
              value={criteria.colorCode}
              lookupRequired={this.props.isShowColorLookup}
              lookupHandler={this.props.colorLookupHandler}
              enterKeyEventHandler={this.fabricColourEnterKeyEventHandler}
              autoCompleteListData={
                this.props.fabricColourPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteFabricColorList}
              showAutoCompleteList={this.props.showAutoCompleteFabricColorList}
              disabled={isDisableFields}
            />
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Style</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.onProductTypeCodeChange}
              name="productType"
              placeholder="productType"
              value={criteria.productType}
              lookupRequired={true}
              lookupHandler={this.props.productTypeLookupHandler}
              enterKeyEventHandler={this.productTypeEnterKeyEventHandler}
              autoCompleteListData={
                this.props.productTypePageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteProductTypeList}
              showAutoCompleteList={this.props.showAutoCompleteProductTypeList}
              disabled={isDisableFields}
            />
          </Col>
          <Col>
            <CollapseComponent
              isOpen={this.props.isCollapsible_open}
              onClick={(e) => this.showHideSecondHeader(e)}
            />
          </Col>
        </Row>
        {this.props.isCollapsible_open && (
          <div>
            <Row>
              <Col sm="1">
                {" "}
                <FormLabel>Type</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  ref={this.patternTypeRef}
                  name="patternType"
                  onChange={this.patternTypeCodeOnChange}
                  value={criteria.patternType}
                  lookupRequired={true}
                  lookupHandler={this.props.patternTypeLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.patternTypeEnterKeyEventHandler}
                  autoCompleteListData={
                    this.props.patternTypePageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayAutoCompletePatternTypeList
                  }
                  showAutoCompleteList={
                    this.props.showAutoCompletePatternTypeList
                  }
                  disabled={isDisableFields}
                />
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>From Date</FormLabel>
              </Col>
              <Col sm="2">
                <DatePickerComponent_adv
                  name="startDate"
                  onChange={this.onChange}
                  value={criteria.startDate}
                  disabled={isDisableFields}
                />
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>To Date</FormLabel>
              </Col>
              <Col sm="2">
                <DatePickerComponent_adv
                  name="stopDate"
                  onChange={this.onChange}
                  value={criteria.stopDate}
                  disabled={isDisableFields}
                />
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>Filter By</FormLabel>
              </Col>
              <Col sm="2">
                <FormControl
                  as="select"
                  custom
                  onChange={this.onChange}
                  name="receivedQuantityDateMode"
                  value={criteria.receivedQuantityDateMode}
                  disabled={isDisableFields}
                >
                  <option value={0}></option>
                  <option value={1}>Purchase Order</option>
                  <option value={2}>PurchaseOrder Receipt</option>
                </FormControl>
              </Col>
            </Row>
            <Row>
              <Col sm="1">
                <FormLabel>Type Category</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  ref={this.patternTypeCategoryRef}
                  name="patternTypeCategory"
                  onChange={this.patternTypeCategoryCodeOnChange}
                  value={criteria.patternTypeCategory}
                  lookupRequired={true}
                  lookupHandler={this.props.patternTypeCategoryLookupHandler}
                  enterKeyEventHandler={
                    this.patternTypeCategoryEnterKeyEventHandler
                  }
                  autoCompleteListData={
                    this.props.patternTypeCategoryPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayAutoCompletePatternTypeCategoryList
                  }
                  showAutoCompleteList={
                    this.props.showAutoCompletePatternTypeCategoryList
                  }
                  disabled={isDisableFields}
                />
              </Col>
            </Row>
          </div>
        )}
        {/* <div>
          <img
            src={this.props.barChatImageUrl}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = noImage;
            }}
            width={100}
            height={100}
            mode="fit"
          />{" "}
        </div> */}
      </div>
    );
  }
}

function FabricStyleSalesInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <FabricStyleSales {...props} name="" /> <br />
    </div>
  );
}

export default FabricStyleSalesInquiry;
